import { Box, Flex, List, ListItem, Text, Heading } from '@chakra-ui/react'
import { useState } from 'react'
import {
  DOPPEL_DARK_SECONDARY,
  DOPPEL_DARK_CLICKABLE_HOVER,
  DOPPEL_TAG_RED,
  DOPPEL_TAG_RED_SHADE,
  FONT_SIZE_MEDIUM,
  FONT_SIZE_SMALL,
  DOPPEL_TEXT_GREY,
  FONT_SIZE_LARGE,
  DOPPEL_BLANK_SHADE,
} from '@/utils/style'
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import { DoppelTag } from '@/components/shared/doppel_tag'

const ICON_SIZE = '5'
const URGENT_TAG_TEXT = 'Urgent'

export type ListItemProps = {
  id: string
  label: string
  details: any
  isUrgent?: boolean
  timestamp?: Date
}

export type ListDetailProps = {
  title?: string
  items: ListItemProps[]
  height?: string
}

export default function ListDetail({ items, title, height }: ListDetailProps) {
  const [selected, setSelected] = useState(null)

  const BORDER = `1px solid ${DOPPEL_BLANK_SHADE}`
  return (
    <Flex bg={DOPPEL_DARK_SECONDARY} height={height ? height : '70vh'} minHeight="40vh">
      <Box borderRight={BORDER} height="auto" overflowY="scroll" width="28%">
        <List height="100%" position="relative" spacing={3}>
          {title && (
            <Heading fontSize={20} fontWeight="bold" height="60px" p={4}>
              {title}
            </Heading>
          )}

          {items && items.length > 0 ? (
            items.map((item) => (
              <ListItem
                _hover={{ bg: DOPPEL_DARK_CLICKABLE_HOVER }}
                bg={
                  selected?.id === item.id ? DOPPEL_DARK_CLICKABLE_HOVER : 'transparent'
                }
                borderBottom={BORDER}
                cursor="pointer"
                key={item.id}
                mt="0 !important"
                onClick={() => {
                  if (selected?.id === item.id) {
                    setSelected(null)
                  } else {
                    setSelected(item)
                  }
                }}
                p={0}
                pl={4}
              >
                <Flex align="center" justify="space-between" p={4}>
                  <Box>
                    <Box fontSize={FONT_SIZE_MEDIUM} fontWeight="500">
                      {item.label}
                    </Box>

                    {item.timestamp && (
                      <Text color={DOPPEL_TEXT_GREY} fontSize={FONT_SIZE_SMALL} mt={1}>
                        {new Date(item.timestamp).toLocaleString()}
                      </Text>
                    )}
                  </Box>

                  <Flex align="center">
                    {item.isUrgent && (
                      <DoppelTag
                        bgColor={DOPPEL_TAG_RED_SHADE}
                        color={DOPPEL_TAG_RED}
                        marginRight={3}
                        tag={URGENT_TAG_TEXT}
                      />
                    )}

                    {selected?.id === item.id ? (
                      <ChevronLeftIcon boxSize={ICON_SIZE} color="white" />
                    ) : (
                      <ChevronRightIcon boxSize={ICON_SIZE} color="white" />
                    )}
                  </Flex>
                </Flex>
              </ListItem>
            ))
          ) : (
            <Box
              alignItems="center"
              display="flex"
              height="100%"
              justifyContent="center"
              mt="0 !important"
              position="absolute"
              top={0}
              width="100%"
            >
              <Text color={DOPPEL_TEXT_GREY}>{"You're all caught up."}</Text>
            </Box>
          )}
        </List>
      </Box>

      {/* Detail Panel */}
      <Box overflowY="scroll" width="72%">
        {selected && selected.id ? (
          <>{selected.details}</>
        ) : (
          <Flex
            align="center"
            color={DOPPEL_TEXT_GREY}
            height="100%"
            justify="center"
            textAlign="center"
          >
            <Text fontSize={FONT_SIZE_LARGE}>No item selected</Text>
          </Flex>
        )}
      </Box>
    </Flex>
  )
}
